import { render, staticRenderFns } from "./WEBMIQMA.vue?vue&type=template&id=904f8b8c"
import script from "./WEBMIQMA.vue?vue&type=script&lang=js"
export * from "./WEBMIQMA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports